import React from 'react';

export default class NotFound extends React.Component {
  constructor(props) {
    super();
    this.state = {};
  }

  render() {
    return (
      <div className="not-found">
        <img
          src="./images/404-img.png"
          alt="not-found"
        />
      </div>
    );
  }
}